// extracted by mini-css-extract-plugin
module.exports = {"expandButton":"SubregionForecastLink_expandButton__Fgh_E"};